import React, { useState, useRef } from "react";
import Section from "../dropdowns/Section";
import Structure from "../dropdowns/MultiStructure";

const FormComponent = ({ action, theme, onClose, project }) => {
  const [formData, setFormData] = useState({
    sectionNames: [], // Multiselect support
    structureNames: [], // Multiselect support
    pierId: "",
    date: "",
    nos: {}, // Nos fields as key-value pairs for each structure
  });

  const cancelButtonRef = useRef(null);

  // Handle input changes for common fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle multiselect changes for Sections and Structures
  const handleMultiSelectChange = (name, values) => {
    setFormData((prev) => ({
      ...prev,
      [name]: values,
    }));
  };

  // Handle dynamic Nos changes for each structure
  const handleNosChange = (structure, value) => {
    setFormData((prev) => ({
      ...prev,
      nos: {
        ...prev.nos,
        [structure]: value,
      },
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data Submitted:", formData);
    // Perform Add, Edit, or Delete action
  };

  // Set theme-based styles
  const themeClasses =
    theme === "dark" ? "bg-gray-800 text-white" : "bg-white text-gray-800";

  return (
    <div className={`p-4 ${themeClasses}`}>
      <h2 className="text-xl font-bold mb-4">
        {action === "Add" && "Add New Entry"}
        {action === "Edit" && "Edit Entry"}
        {action === "Delete" && "Delete Entry"}
      </h2>
      <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">
        {/* Section Names (Multiselect) */}
        <div className="mb-4">
          <label htmlFor="sectionNames" className="block font-medium mb-2">
            Sections
          </label>
          <Section
            selectedValues={formData.sectionNames}
            onChange={(values) => handleMultiSelectChange("sectionNames", values)}
          />
        </div>

        {/* Structure Names (Multiselect) */}
        <div className="mb-4">
          <label htmlFor="structureNames" className="block font-medium mb-2">
            Structures
          </label>
          <Structure
            values={formData.structureNames}
            onChange={(values) => handleMultiSelectChange("structureNames", values)}
          />
        </div>

        {/* Pier ID */}
        <div className="mb-4">
          <label htmlFor="pierId" className="block font-medium mb-2">
            Pier ID
          </label>
          <input
            type="text"
            id="pierId"
            name="pierId"
            value={formData.pierId}
            onChange={handleChange}
            className={`p-2 border rounded w-full ${themeClasses}`}
            required={action !== "Delete"}
            disabled={action === "Delete"}
          />
        </div>

        {/* Date */}
        <div className="mb-4">
          <label htmlFor="date" className="block font-medium mb-2">
            Date
          </label>
          <input
            type="date"
            id="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            className={`p-2 border rounded w-full ${themeClasses}`}
            required={action !== "Delete"}
            disabled={action === "Delete"}
          />
        </div>

        {/* Dynamic Nos Fields */}
        {formData.structureNames.map((structure, index) => (
          <div key={structure} className="mb-4">
            <label htmlFor={`nos-${structure}`} className="block font-medium mb-2">
              Nos for {structure}
            </label>
            <input
              type="number"
              id={`nos-${structure}`}
              name={`nos-${structure}`}
              value={formData.nos[structure] || ""}
              onChange={(e) => handleNosChange(structure, e.target.value)}
              className={`p-2 border rounded w-full ${themeClasses}`}
              required={action !== "Delete"}
              disabled={action === "Delete"}
            />
          </div>
        ))}

        {/* Action Buttons */}
        <div className="px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse justify-between col-span-2">
          <button
            type="submit"
            className="py-2 px-4 rounded-md bg-blue-500 hover:bg-blue-700 text-white text-md"
          >
            {action}
          </button>
          <button
            type="button"
            className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:mt-0 sm:w-auto"
            onClick={onClose}
            ref={cancelButtonRef}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default FormComponent;
